import { ArrowLeftOutlined } from '@ant-design/icons';
import { EnumCambiamentoStatoRequestTransizione } from '@framework/api-client/api/inquiries-compile/schemas/enumCambiamentoStatoRequestTransizione.ts';
import { useCurrentUser } from '@framework/auth/state/AuthSlice.tsx';
import { SubmissionModuleState } from '@framework/common-web/frontoffice/module/fsm/SubmissionModuleState.ts';
import {
  type IModuleStateMachineRecord,
  ModuleStateMachine,
} from '@framework/frontoffice-submission/module/fsm/ModuleStateMachine.ts';
import { ActionButtonContainer } from '@framework/frontoffice-submission/submission/signer/ActionButtonContainer.tsx';
import { ActionMessage } from '@framework/frontoffice-submission/submission/signer/ActionMessage.tsx';
import { AsyncButton } from '@framework/ui/components/button/AsyncButton.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSubmissionModuleStateChanger } from './useSubmissionModuleStateChanger.ts';

export interface ISignToCompilationButtonProps {
  data: IModuleStateMachineRecord;
}

export function SignToCompilationButton(props: ISignToCompilationButtonProps) {
  const { data } = props;

  const currentUser = useCurrentUser();
  const { t } = useTranslation();

  const canSignToCompilation = useMemo(() => {
    return ModuleStateMachine.canTransition(data, {
      from: SubmissionModuleState.Sign,
      to: SubmissionModuleState.Compilation,
      user: currentUser,
    });
  }, [currentUser, data]);

  const { handleClick } = useSubmissionModuleStateChanger({
    data,
    successMessage: t(
      'submission-action-button.modulo-nuovamente-compilabile',
      'Modulo nuovamente compilabile',
    ),
  });

  if (!canSignToCompilation.allowed) return null;

  return (
    <ActionButtonContainer
      message={
        <ActionMessage
          message={t(
            'submission-action-button.modulo-compilato-ritornare-in-compilazione-per-modificare',
            'Il modulo è stato compilato, puoi ritornare in compilazione se sono necessarie modifiche.',
          )}
          type="info"
        />
      }
      button={
        <AsyncButton
          block
          size="large"
          onClick={() =>
            handleClick(
              EnumCambiamentoStatoRequestTransizione.RIPORTA_IN_COMPILAZIONE,
            )
          }
        >
          <ArrowLeftOutlined aria-hidden="true" />{' '}
          {t(
            'submission-action-button.ritorna-in-compilazione',
            'Ritorna in compilazione',
          )}
        </AsyncButton>
      }
    />
  );
}
